"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketMessageKind = void 0;
var WebSocketMessageKind;
(function (WebSocketMessageKind) {
    WebSocketMessageKind["Failure"] = "?:failure";
    WebSocketMessageKind["RpcRequest"] = "rpc:request";
    WebSocketMessageKind["RpcResponse"] = "rpc:response";
    WebSocketMessageKind["RpcFailure"] = "rpc:failure";
    WebSocketMessageKind["BuzzerRequest"] = "buzzer:request";
    WebSocketMessageKind["BuzzerResponse"] = "buzzer:response";
    WebSocketMessageKind["BuzzerFailure"] = "buzzer:failure";
    WebSocketMessageKind["StreamS2C"] = "stream:s2c";
    WebSocketMessageKind["StreamC2S"] = "stream:c2s";
})(WebSocketMessageKind = exports.WebSocketMessageKind || (exports.WebSocketMessageKind = {}));
//# sourceMappingURL=transport.websocket.js.map